import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=f6661606&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&lang=ts"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=f6661606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6661606",
  null
  
)

export default component.exports